var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container",class:{ 'hide-control': !_vm.controls, 'hide-loading': _vm.hideLoading }},[_c('div',{staticClass:"video-box",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }